import { useMutation } from 'react-query';
import { AccessTokenResponse, LoginRequest } from '@dopingtech/live_expert_bff_api_ts';
import { useApi } from '@/api/useApi.tsx';
import { useAuthStore } from '@/zustand/auth/store.ts';
import ExceptionManager from '@/managers/exception-manager.tsx';
import { useAppSettings } from '@/zustand/app-settings/store.ts';
import { TimeSpan } from '@/utility/time-span.ts';
import { useState } from 'react';

export const AUTH_QUERY_KEYS = {
	LOGIN: 'LOGIN'
};

export const useLogin = () => {
	const [isLoading, setIsLoading] = useState(false);
	const { clearData: clearAppSettings } = useAppSettings();
	const { setData, clearData: clearAuth } = useAuthStore();
	const { LoginControllerApi } = useApi();

	const { mutate: loginMutate } = useMutation(AUTH_QUERY_KEYS.LOGIN, (body: LoginRequest) => LoginControllerApi.login(body), {
		retry: false
	});

	const loginMutation = (body: LoginRequest, callback?: (response: AccessTokenResponse, errorData?: any) => void) => {
		clearAppSettings();
		clearAuth();

		setIsLoading(true);

		setTimeout(() => {
			loginMutate(body, {
				onSuccess: (response: any) => {
					setIsLoading(false);

					setData({
						...response.data,
						user: response.data?.user
					});
					setTimeout(() => {
						if (callback) {
							callback(response.data);
						}
					}, TimeSpan.milliSecond.threeHundredFifty);
				},
				onError: (error: any) => {
					setIsLoading(false);

					const customErrors = ['LE101', 'LE-USER401'];
					if (customErrors.includes(error?.response?.data?.error)) {
						if (callback) {
							callback({} as AccessTokenResponse, error?.response?.data);
						}
						return error?.response?.data;
					} else {
						ExceptionManager.errorHandler(error);
						if (callback) {
							callback({} as AccessTokenResponse, error?.response?.data || { error: 'UNKNOWN_ERROR' });
						}
					}
				}
			});
		}, TimeSpan.milliSecond.twoHundred);
	};

	return {
		loginMutation,
		loginLoading: isLoading
	};
};
